import { UserRoles } from '../../../../types/models/user/user.types';
import RegisterCompanyStep from './RegisterCompanyStep/RegisterCompanyStep';
import RegisterCompanyStepForm from './RegisterCompanyStep/RegisterCompanyStepForm/RegisterCompanyStepForm';
import RegisterConfirmationBisStep from './RegisterConfirmationBisStep/RegisterConfirmationBisStep';
// import RegisterConfirmationStep from "./RegisterConfirmationStep/RegisterConfirmationStep";
import RegisterDocumentsStep from './RegisterDocumentsStep/RegisterDocumentsStep';
import RegisterEntityStep from './RegisterEntityStep/RegisterEntityStep';
import RegisterEntityStepForm from './RegisterEntityStep/RegisterEntityStepForm/RegisterEntityStepForm';
import RegisterPUBDocumentsStep from './RegisterPUBDocumentsStep/RegisterPUBDocumentsStep';
import RegisterPendingStep from './RegisterPendingStep/RegisterPendingStep';
import RegisterSignUpStep from './RegisterSignUpStep/RegisterSignUpStep';
import RegisterSignUpStepForm from './RegisterSignUpStep/RegisterSignUpStepForm/RegisterSignUpStepForm';
import { RegisterData, RegisterStepsList } from './RegisterSteps.types';
import { getRegisterStepPath } from './RegisterSteps.utils';
import RegisterUserStep from './RegisterUserStep/RegisterUserStep';
import RegisterUserStepForm from './RegisterUserStep/RegisterUserStepForm/RegisterUserStepForm';
import RegisterValidationStep from './RegisterValidationStep/RegisterValidationStep';

export const newRegisterSteps = Object.freeze({
  [UserRoles.AcheteurPublic]: [
    {
      step: 1,
      component: RegisterSignUpStepForm,
      title: 'Identification',
      subtitle: 'Entrez vos informations de connexion',
      backDisabled: true,
    },
    {
      step: 2,
      component: RegisterEntityStepForm,
      title: 'Entité',
      subtitle: 'Entrez les informations de votre entité',
      backDisabled: true,
    },
    {
      step: 3,
      component: RegisterUserStepForm,
      title: 'Utilisateur',
      subtitle: "Entrez les informations de l'utilisateur",
      backDisabled: true,
    },
    {
      step: 4,
      component: RegisterPUBDocumentsStep,
      title: 'Documents',
      subtitle: "Document d'inscription",
      backDisabled: true,
    },
    {
      step: 5,
      component: RegisterValidationStep,
      title: 'En attente',
      subtitle: "Compte en attente de validation",
    },
  ],
  [UserRoles.Entreprise]: [
    {
      step: 1,
      component: RegisterSignUpStepForm,
      title: 'Identification',
      subtitle: 'Entrez vos informations de connexion',
      backDisabled: true,
    },
    {
      step: 2,
      component: RegisterCompanyStepForm,
      title: 'Entreprise',
      subtitle: 'Entrez les informations de votre entreprise',
      backDisabled: true,
    },
    // {
    //   step: 3,
    //   component: RegisterDocumentsStep,
    //   title: 'Documents',
    //   subtitle: 'KBIS de votre entreprise',
    //   backDisabled: true,
    // },
    {
      step: 3,
      component: RegisterConfirmationBisStep,
      title: 'Confirmation',
      subtitle: 'Terminez votre inscription',
    },
  ],
  [UserRoles.Commercial]: [],
  [UserRoles.DirecteurCommercial]: [],
});

export const registerSteps = Object.freeze<RegisterData>({
  [UserRoles.AcheteurPublic]: {
    [RegisterStepsList.SignUp]: {
      component: RegisterSignUpStep,
      path: getRegisterStepPath(RegisterStepsList.SignUp),
    },
    [RegisterStepsList.Entity]: {
      component: RegisterEntityStep,
      path: getRegisterStepPath(RegisterStepsList.Entity),
    },
    [RegisterStepsList.User]: {
      component: RegisterUserStep,
      path: getRegisterStepPath(RegisterStepsList.User),
    },
    [RegisterStepsList.Documents]: {
      component: RegisterDocumentsStep,
      path: getRegisterStepPath(RegisterStepsList.Documents),
    },
    [RegisterStepsList.Pending]: {
      component: RegisterPendingStep,
      path: getRegisterStepPath(RegisterStepsList.Pending),
    },
  },
  [UserRoles.Entreprise]: {
    [RegisterStepsList.SignUp]: {
      component: RegisterSignUpStep,
      path: getRegisterStepPath(RegisterStepsList.SignUp),
    },
    [RegisterStepsList.Company]: {
      component: RegisterCompanyStep,
      path: getRegisterStepPath(RegisterStepsList.Company),
    },
  },
  [UserRoles.Commercial]: {},
  [UserRoles.DirecteurCommercial]: {},
});
